/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Card_TitleInputs */

const cs_pm_card_title = /** @type {(inputs: Pm_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapování ID inzerátů`)
};

const en_pm_card_title = /** @type {(inputs: Pm_Card_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing ID mapping`)
};

/**
* | output |
* | --- |
* | "Listing ID mapping" |
*
* @param {Pm_Card_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_card_title = /** @type {((inputs?: Pm_Card_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Card_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_card_title(inputs)
	return cs_pm_card_title(inputs)
});